import axios from 'axios';

const getOnboardingPortalIds = async () => {
  const { data } = await axios.get<{
    TRREB: string;
  }>('/secrets/onboardingPortalIds');

  return data;
};

export default getOnboardingPortalIds;
